export const formatLocationName = (location) => {
  if (!location) return ""
  const split = location.split("-")
  const isTwoWords = split[0].split(" ").length > 1
  return (
    split[0].split(" ")[0] + `${isTwoWords ? " " + split[0].split(" ")[1] : ""}`
  )
}
